import { useState } from "react";
import { Loader2, Key, Check } from "lucide-react";
import api, { apiErr } from "../../lib/api";
import { toast } from "sonner";

// Credenciales de Instagram (ig_user_id + token de larga duración) — se guardan cifradas en
// el backend (ver ig_reels.py::_cipher) y nunca se vuelven a mostrar en claro, igual que las
// API keys de Growth.
export default function IgReelsConfigPanel({ config, onSaved }) {
  const [igUserId, setIgUserId] = useState("");
  const [accessToken, setAccessToken] = useState("");
  const [busy, setBusy] = useState(false);

  const save = async () => {
    if (!igUserId.trim() || !accessToken.trim()) { toast.warning("Rellena los dos campos"); return; }
    setBusy(true);
    try {
      await api.post("/ig-reels/config", { ig_user_id: igUserId.trim(), access_token: accessToken.trim() });
      toast.success("Credenciales guardadas.");
      setAccessToken("");
      onSaved();
    } catch (e) { toast.error(apiErr(e)); } finally { setBusy(false); }
  };

  return (
    <div className="rounded-xl border border-slate-200 bg-white p-4" data-testid="igreels-config">
      <h3 className="mb-3 flex items-center gap-2 text-sm font-semibold text-slate-700"><Key size={16} /> Credenciales de Instagram</h3>
      {config?.configured && (
        <p className="mb-3 flex items-center gap-1.5 text-xs font-medium text-emerald-700">
          <Check size={14} /> Configurado — IG User ID: {config.igUserId}
        </p>
      )}
      <div className="flex flex-wrap gap-2">
        <input value={igUserId} onChange={(e) => setIgUserId(e.target.value)} placeholder="IG User ID"
          data-testid="igreels-config-userid" className="min-w-[160px] flex-1 rounded-lg border border-slate-200 px-3 py-1.5 text-sm" />
        <input value={accessToken} onChange={(e) => setAccessToken(e.target.value)} type="password"
          placeholder="Access token de larga duración" data-testid="igreels-config-token"
          className="min-w-[220px] flex-[2] rounded-lg border border-slate-200 px-3 py-1.5 text-sm" />
        <button onClick={save} disabled={busy} data-testid="igreels-config-save"
          className="flex items-center gap-1.5 rounded-lg bg-slate-900 px-3 py-1.5 text-sm font-semibold text-white hover:bg-slate-800 disabled:opacity-60">
          {busy && <Loader2 size={14} className="animate-spin" />} Guardar
        </button>
      </div>
      <p className="mt-2 text-xs text-slate-400">
        El token se cifra antes de guardarse y no se vuelve a mostrar completo. Caduca a los ~60 días — hay que renovarlo desde aquí cuando Meta lo avise.
      </p>
    </div>
  );
}
